import { AdvancedFilterData } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import { ArrayStringFilterOperator } from "@redotech/redo-views-common/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-views-common/advanced-filters/generic-advanced-filter-data";
import { SortDirection, TableSort } from "@redotech/redo-views-common/table";
import { DEFAULT_PAGE_SIZE, viewTypes } from "./views";

export enum WorkOrderSystemView {
  ALL = "all",
  NOT_STARTED = "not-started",
  IN_PROGRESS = "in-progress",
  COMPLETED = "completed",
  CREATE = "create",
}

const sortDefault: TableSort = {
  direction: SortDirection.DESC,
  key: "orderCreatedAt",
};

const notStartedFilter: AdvancedFilterData = {
  name: "status",
  type: AdvancedFilterType.ARRAY_TO_STRING,
  value: ["not_started"],
  operator: ArrayStringFilterOperator.ANY_OF,
};

const inProgressFilter: AdvancedFilterData = {
  name: "status",
  type: AdvancedFilterType.ARRAY_TO_STRING,
  value: ["in_progress"],
  operator: ArrayStringFilterOperator.ANY_OF,
};

const completedFilter: AdvancedFilterData = {
  name: "status",
  type: AdvancedFilterType.ARRAY_TO_STRING,
  value: ["completed"],
  operator: ArrayStringFilterOperator.ANY_OF,
};

const defaultColumns = [
  { key: "externalOrderId", width: 150, hidden: false },
  { key: "status", width: 140, hidden: false },
  { key: "currentStepTitle", width: 150, hidden: false },
  { key: "triggerKind", width: 130, hidden: false },
  { key: "orderCreatedAt", width: 160, hidden: false },
  { key: "quantity", width: 100, hidden: false },
  { key: "pickLines", width: 100, hidden: false },
  { key: "createdAt", width: 160, hidden: false },
  { key: "updatedAt", width: 160, hidden: true },
  { key: "completedAt", width: 160, hidden: true },
  { key: "fulfillmentGroupId", width: 150, hidden: true },
];

export const StaticSystemViews: Record<
  Exclude<WorkOrderSystemView, WorkOrderSystemView.CREATE>,
  viewTypes["work-orders"]
> = {
  [WorkOrderSystemView.ALL]: {
    table: "work-orders",
    name: WorkOrderSystemView.ALL,
    filters: [],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 0,
  },
  [WorkOrderSystemView.NOT_STARTED]: {
    table: "work-orders",
    name: WorkOrderSystemView.NOT_STARTED,
    filters: [notStartedFilter],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 1,
  },
  [WorkOrderSystemView.IN_PROGRESS]: {
    table: "work-orders",
    name: WorkOrderSystemView.IN_PROGRESS,
    filters: [inProgressFilter],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 2,
  },
  [WorkOrderSystemView.COMPLETED]: {
    table: "work-orders",
    name: WorkOrderSystemView.COMPLETED,
    filters: [completedFilter],
    columns: defaultColumns,
    pageSize: DEFAULT_PAGE_SIZE,
    sort: sortDefault,
    position: 3,
  },
};

const FRIENDLY_NAMES: Record<string, string> = {
  [WorkOrderSystemView.ALL]: "All work orders",
  [WorkOrderSystemView.NOT_STARTED]: "Not started",
  [WorkOrderSystemView.IN_PROGRESS]: "In progress",
  [WorkOrderSystemView.COMPLETED]: "Completed",
};

export function friendlyViewName(view: viewTypes["work-orders"]) {
  return FRIENDLY_NAMES[view.name] ?? view.name;
}
